import type { RootState } from "@/app/store";

export const selectKillSkill = (state: RootState) => state.killSkill;
export const selectNextTrainTime = (state: RootState) =>
  state.killSkill.nextTrainTime;
export const selectIsTrainingKill = (state: RootState) =>
  state.killSkill.isTrainingKill;
export const selectTrainRequest = (state: RootState) =>
  state.killSkill.trainRequest;
